import { render, staticRenderFns } from "./IconCart.vue?vue&type=template&id=66a905b4&"
import script from "./IconCart.vue?vue&type=script&lang=js&"
export * from "./IconCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports